import RequestAbstract from "../abstract";

export default class PublicCurrencyRates extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-currency-rates";
    }

}
